import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, string } from "prop-types";
import { push } from "connected-react-router";
import { selectors as investmentfundsSelectors } from "reducers/investmentfunds";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Col from "react-bootstrap/lib/Col";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";

class AccountNoProfile extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        route: string.isRequired,
    };

    render() {
        const { fetching, dispatch, route } = this.props;
        return (
            <>
                <Notification scopeToShow="investmentfunds" />
                <ResponsiveHeader
                    id="investmentFunds.add.account.title"
                    className="header-without-button"
                    backLinkTo={route}
                />
                <MainContainer className="main-container">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <Col xs={12} md={10} mdOffset={1}>
                                <div className="mb-3">
                                    <I18n id="investmentFunds.add.account.noProfile.p1" />
                                </div>
                                <div className="mb-2 font-bold">
                                    <I18n id="investmentFunds.add.account.noProfile.subtitle" />
                                </div>
                                <div className="mb-5">
                                    <I18n id="investmentFunds.add.account.noProfile.p2" />
                                </div>
                            </Col>
                        </Row>
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4}>
                                <div className="toolbar-item add-button" key="add">
                                    <Button
                                        bsStyle="primary"
                                        label="global.continue"
                                        loading={fetching}
                                        onClick={() => dispatch(push("/investmentFunds/accounts/add"))}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    route: investmentfundsSelectors.getRoute(state),
});
export default connect(mapStateToProps)(AccountNoProfile);
